<template>
  <div class="video" :style="{background:videoBg}" @mouseup="videoClick">
    <!--头部 开始-->
    <div class="top">
      <img
        @click="goCourse"
        class="back cursor"
        src="../../../assets/img/common/back.png"
        ondragstart="return false;"
        alt="加载失败"
        v-if="!govideo"
      />
      <span
        v-if="!isExperientialCourse"
        class="cursor network_status"
        :class="{'network_poor':networkStatus===0,'network_general':networkStatus===1,'network_good':networkStatus===2}"
        @click="networkTestDescribeIsShow=true"
      ></span>
      <div class="goldnum">
        <div class="goldlottie"></div>
        {{lessonCoin}}
<!--        <coinex from="video" v-if="!isExperientialCourse"></coinex>-->
      </div>
      <!--金币动画 -->
      <div
        v-for="(item,index) in addcoin_list.length>10?11:addcoin_list"
        :key="index"
        class="goldnum animation_gold"
        :style="{animationDelay:index*0.05+'s',opacity:Math.abs((index-10)*0.1)<=0?0.1:Math.abs((index-10)*0.1),paddingRight:!isExperientialCourse?'40px':'16px'}"
      >{{lessonCoin}}</div>
      <transition name="slideTop">
        <!-- <span class="gold_add">+4</span> -->
        <span class="gold_add" v-if="addcoin_num">+{{addcoin_list.length}}</span>
      </transition>
      <div class="teacher_img">
        <img src="../../../assets/img/home/logo.png" ondragstart="return false;" alt v-if="class_type === 9"/>
        <img :src="teacher_avatar_url" ondragstart="return false;" alt v-else/>
      </div>
    </div>
    <!--头部 结束-->
    <div class="play_video">
      <div class="play_video_sub" id='play_video_sub' :style="{width:videoWH.w+'px',height:videoWH.h+'px' }">
        <!--课件-->
        <kejian
          @closeIframe="closeQuestion"
          @countDown="showClock"
          @showToast="showKejianToast"
          @voiceStop="voiceStop"
          @loadGameSuccess='loadGameSuccess=true'
          @sendPreClassTestBarrage="sendPreClassTestBarrage"
          :subType="kejianQuestionSubType"
          :type="kejianQuestionType"
          :iframeQuickId="iframeQuickId"
          :iframeRight="questionRight"
          :unique_id="iframeUniqueId"
          :answerType="iframeAnswerType"
          :gameName="gameName"
          :questionids="questionids"
          :count="countNumber"
          :timeOver="timeOver"
          :preClassTestBgImage="preClassTestBgImage"
          ref="kejian"
        />
        <!--播放器 体验课/录播课-->
        <!--AI课程-->
        <videoplayerforai
          ref="videoplayerforai"
          v-if="class_type === 9"
          @tip="videoTipEvent"
          @loaderr="videoLoadErr"
          @canNotPlay = "canNotPlay"
          @firstPlay="playerEnterShow=true"
          :showExeriseList="showExeriseList"
          :rateArr="rateArr"
          :rateIndex="rateIndex"
          :progressBar="progressBar"
          @changeRateIndex="changeRateIndex"
          @clickTagSwitch="clickTagSwitch"
          @playClassBeginAudio="playClassBeginAudio"
        />
        <videoplayer
          ref="videoplayer"
          v-else-if="isExperientialCourse || class_type === 10"
          @tip="videoTipEvent"
          @loaderr="videoLoadErr"
          @firstPlay="playerEnterShow=true"
        />
        <Vlcplayer
          ref="vlcPlayer"
          v-else-if="playerType()==='vlc' && apiLessonInState===1"
          :aiSwitchVideoUrl="aiSwitchVideoUrl"
          @tip="videoTipEvent"
          @loaderr="videoLoadErr"
          @videoSpeed="setNetworkStatus"
          @autoSwitchVideoUrl="autoSwitchVideoUrl"
        />
        <flvplayer
          v-else-if="apiLessonInState===1"
          :aiSwitchVideoUrl="aiSwitchVideoUrl"
          @tip="videoTipEvent"
          @loaderr="videoLoadErr"
          @firstPlay="playerEnterShow=true"
          @videoSpeed="videoSpeed"
          @autoSwitchVideoUrl="autoSwitchVideoUrl"
        />
        <img class="class_over" v-if="classOverImgShow" src="/static/img/video/classover.jpg" alt="">
        <!--播放器上层遮罩-->
        <div class="play_video_mask" v-if="![121,123,124].includes(lesson_type) && class_type != 9 && class_type != 10"></div>
      </div>
    </div>
    <!--底部开始-->
    <div class="bottom">
      <div class="whl-student-head-container">
        <div></div>
        <div @click="switchExpressionBox(true)">
          <img
            class="cursor"
            :src="user_photo"
            alt
            ondragstart="return false;"
          />
          <img :src="userHeadwear" alt="" v-if="!time_on_off && userHeadwear">
        </div>
      </div>
      <div class="danmu_box" v-show="!showComments">
        <span class="rate cursor" @click="clickTagSwitch(3)" v-if="speedShow && this.playBar == 1 && (this.lesson_type == 1 || this.lesson_type == 3)">{{
            `${rateArr[rateIndex]}X`
          }}</span>
        <div
          class="switch cursor"
          :class="{'switch--disable':currentStatus==='linking' || apiLessonInState!==1  || currentStatus==='talking' || switchBtnState===0 || iframeQuickId!=='' || a_on_off || JSON.stringify(liveVideoUrlData.live_video_url_list)==='{}','switch--active':switchBtnState===2&& iframeQuickId==='' &&  !a_on_off}"
          @mouseup.stop="switchVideoUrl"
        >{{shortName}}</div>

        <div class="line"></div>
        <img
          class="cursor"
          ondragstart="return false;"
          @click="changeDanmu"
          :src="danmuShow? '/static/img/video/danmu_open.png':'/static/img/video/danmu_close.png'"
          alt
        />
        <img
          v-if="!issafariBrowser"
          class="cursor screenshots"
          :class="{'screenshots--disable':currentStatus==='linking' || currentStatus==='talking'}"
          ondragstart="return false;"
          @click.stop="screenshots()"
          src= 'static/img/playback/screenshots.png'
        />
        <img
          class="cursor"
          ondragstart="return false;"
          @mouseup.stop="showMoreBtn"
          src="../../../assets/img/video/more.png"
          alt
        />
      </div>
      <div class="morebtn" @mouseup.stop v-show="morebtnShow">
        <p>
          护眼模式
          <input type="checkbox"  @change="toggoleProtect(true)" v-model="openEye" id="eyeopen">
          <label for="eyeopen" class="cursor"></label>
        </p>
        <p v-if="this.playBar == 1 && (this.lesson_type == 1 || this.lesson_type == 3)">
          进度条
          <input type="checkbox"  @change="toggoleProgressBar()" v-model="progressBar" id="progressBar">
          <label for="progressBar" class="cursor"></label>
        </p>
        <p>
          连对效果
          <input type="checkbox"  @change="setConAnimShow()" v-model="conAnimShow" id="conAnim">
          <label for="conAnim" class="cursor"></label>
        </p>
        <p v-if="this.playBar == 1 && (this.lesson_type == 1 || this.lesson_type == 3)">
          倍速
          <input type="checkbox"  @change="setSpeedShow()" v-model="speedShow" id="speed">
          <label for="speed" class="cursor"></label>
        </p>
      </div>
      <div
        class="switch_box"
        v-show="switchBtnState===2 && iframeQuickId==='' &&  !a_on_off&&!showComments"
        @mouseup.stop
      >
        <!-- switch_box_content--active -->
        <div class="switch_box_content">
          <p>清晰度</p>
          <button
            v-for="(item,i) in liveVideoUrlData.live_video_url_list[liveVideoUrlData.live_video_url_stream]&&liveVideoUrlData.live_video_url_list[liveVideoUrlData.live_video_url_stream].list"
            :class="{'switch_box_content--active':liveVideoUrlData.live_video_url_type==item.type}"
            class="cursor"
            @click="verifyVideoUrl(2,item.type, true)"
            :key="i"
          >
            {{item.shortName}}
            <i
              v-if="item.type==='ai' && liveVideoUrlData.live_video_url_type==='ai' && liveVideoUrlData.live_video_url_list[liveVideoUrlData.live_video_url_stream]"
            >{{liveVideoUrlData.live_video_url_list[liveVideoUrlData.live_video_url_stream].list[liveVideoUrlData.live_video_url_sub_type].shortName}}</i>
          </button>
        </div>
        <div class="switch_box_content">
          <p>线路</p>
          <button
            v-for="(item,i) in liveVideoUrlData.live_video_url_list"
            @click="verifyVideoUrl(1,item.type, true)"
            class="cursor"
            :class="{'switch_box_content--active':liveVideoUrlData.live_video_url_stream==item.type}"
            :key="i"
          >{{item.name}}</button>
        </div>
        <div class="switch_box_content">
          <p>视频格式</p>
          <button class="cursor switch_box_content--active">主格式</button>
        </div>
      </div>
      <div class="switch_hint" v-show="switchToastShow">
        {{switchToastText}}
        <span v-if="liveVideoUrlData.live_video_url_list[liveVideoUrlData.live_video_url_stream]">【{{liveVideoUrlData.live_video_url_list[liveVideoUrlData.live_video_url_stream].list[liveVideoUrlData.live_video_url_sub_type].name}}】</span>
        <i v-show="switchVideoUrlSuccess">请稍后...</i>
      </div>
    </div>
    <!--底部 结束-->
    <!--答题区域-->
    <transition :name="timu_message.type==='xuanze'?'xz':'tk'">
      <answer
        :value="value"
        v-show="a_on_off"
        :a_on_off="a_on_off"
        :k_on_off="k_on_off"
        :datas="timu_message"
        @dati_xz="dati_xz"
        @dati_tk="dati_tk"
        @sure="sure"
        @txt_sure="txt_sure"
      />
    </transition>
    <!-- 倒计时 -->
    <transition name="countDown">
      <countDown v-if="time_on_off" :countDownVal="countDownVal" @closeClock="closeQuestion" />
    </transition>
    <!--弹幕-->
    <danmu-list
      :style="{right:barragePositionNum+'px'}"
      :danmuHeight="(gameName && loadGameSuccess) || (loadingErrShow || apiLessonInState===2) || loadingShow?50:danmuHeight"
      :list="danmuList" v-show="!showComments && danmuShow"
    />
    <!-- 键盘区域 -->
    <keyboard
      :input_type="Keyboard_type"
      v-show="k_on_off"
      v-on:changeinput="changeinput"
      ref="keyboard"
      @sure="sure"
    />
    <!-- 语音连麦 -->
    <telephone-panel v-if="currentStatus" :telephoneClass="telephoneClass" :status="currentStatus" @answerTel="onAnswer"></telephone-panel>
    <!-- 送礼物 -->
    <sendGift v-if="giftSwitchUniqueId" :giftData="imageResources.gift || {}" ref="sendGift"/>
    <!-- 自定义表情和话术：层级为90 -->
    <!-- 点击mask关闭自定义表情和话术 :层级为90-->
    <div
      class="control-wordsandexpression-mask cursor"
      v-show="showExpressionFlag"
      @click="switchExpressionBox(false)"
    ></div>
    <wordsAndExpression :showExpression="showExpressionFlag" @close="switchExpressionBox(false)" :data="imageResources" @clickItem="sendWordsOrExpression" />
    <!-- 表扬/鼓励/连麦举手 -->
    <praise v-if="praiseOrEncourageShow" :type="praiseOrEncourageShow" @close="praiseOrEncourageShow = 0"/>
    <!--禁言动画-->
    <bandedAnimate v-if="showAnimate" />
    <!--发送弹幕过快提示-->
    <bandedAlert :bandedType="bandedType" />
    <!-- 你真棒动画 -->
    <motivate :answerResults="answerResults" :answerAdd="answerAdd" v-if="answerResults" @animEnd="onLottieEnd" />
    <continuous :continuousData="continuousData" @animEnd="continuousData={}" v-if="continuousData.level"  />
    <!-- 评价页面-->
    <Evaluation :cData="commentsData" v-if="showComments" @toggleComment="toggleComment" />
    <!--徽章-->
    <div class="badge_mask" v-if="badgeData"></div>
    <transition name="badge">
      <badge :badgeData="badgeData" v-if="badgeData" @badgeCallback="badgeCallback"></badge>
    </transition>
    <!--课中答题排行榜-->
    <ranking
      v-if="rankingData"
      :rankingData="rankingData"
      @ranking_close="rankingData = ''"
    />
    <!-- 徽章排行榜-->
    <BadgeRank v-if="badgeRank" :datas="badgeRank" @ranking_close="badgeRank = false" />
    <!--loading-->
    <loading v-show="loadingShow  && !classOverImgShow" :bg="true"></loading>
    <!-- 视频加载失败 -->
    <loaderr
      v-show="(loadingErrShow || (apiLessonInState===2 && !isExperientialCourse)) && !classOverImgShow"
      @loadvideo="loadvideo"
      @changeStream="changeStream"
      :streamList="streamList"
      :loadErrText="loadErrText"
    />
    <!-- 视频首次播放失败  -->
    <playerEnter v-if="playerEnterShow" @firstPlayVideo="firstPlayVideo" />
    <!-- toast弹窗-->
    <Toast
      :showText="showText"
      :waitTime="toastTime"
      :needMask="showToast!==1"
      v-if="showToast"
      @toastCallBack="toastCallBack"
    />
    <!-- 网络检测弹窗说明 -->
    <networkTestDescribe v-if="networkTestDescribeIsShow" @close="networkTestDescribeIsShow=false" />
    <!-- 语音评测结果页 -->
     <voiceEvalResults v-if="voiceEvalData" :voiceEvalData="voiceEvalData" @close="voiceEvalData=''" />
    <pk ref="pk" v-show="pkData.state" @closePK="pkData=''" :pkData="pkData"></pk>
    <alert
      v-if="alertText"
      :show="alertText!=''"
      :sameOne="alertText"
      cancal="我知道了"
      @cancelEvent="alertText=''"
    ></alert>
    <alert
      v-if="exitalert===1"
      :show="exitalert===1"
      sameOne="正在发言中"
      sameTwo="是否确定要退出直播"
      cancal="取消"
      btn="确定"
      @ensure="exitEnsure"
      @cancelEvent="exitalert=0"
    ></alert>
    <div class="cache"></div>
  </div>
</template>

<script>
import Answer from "./answer/answer.vue";
import DanmuList from "./danmuList.vue";
import flvplayer from "./flvplayer"; //播放器
import Vlcplayer from "./vlcplayer"; //播放器
import videoplayer from "./videoplayer"; //播放器
import videoplayerforai from "./videoPlayerForAi"; //播放器 for ai
import kejian from "./answer/kejian"; //课件题
import Evaluation from "./evaluation.vue";
import wordsAndExpression from "./wordsAndExpression.vue"; //话术表情框
import sendGift from "./sendGift/sendGift.vue"; //送礼物
import praise from "./praise.vue"; //表扬鼓励
import bandedAlert from "./bandedAlert.vue"; //系统禁言时的提示
import bandedAnimate from "./bandedAnimate.vue"; //老师禁言时候的提示
import Keyboard from "./keyboard.vue";
import motivate from "./motivate.vue"; //答对动画
import continuous from "./continuous.vue"; //连对动画
import badge from "./badge.vue"; //徽章
import coinex from "@/components/basic/coinex.vue"//本课时金币提示
import liSrv from "liSrv";
import loaderr from "./loaderr.vue"; //视频加载失败
import countDown from "./countDown.vue"; //徽章
import ranking from "./ranking.vue"; //答题排行榜
import BadgeRank from "./badgeRank.vue"; //答题排行榜
import playerEnter from "./playerenter.vue"; //视频加载失败
import Toast from "../../basic/toast"; //Toast
import loading from "@/components/basic/videoloading";
import telephonePanel from "../../basic/telephonePanel";
import telephoneBase from "./mix/telephoneBase";
import networkTestDescribe from "./networkTestDescribe"; //网络检测弹窗说明
import pk from "./pk/pk.vue";
import pkJs from "./pk/pk.js";
import answerJs from "./answer/answer.js";
import alert from "@/components/basic/alert.vue";
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import common from "common";
import utils from "utils";
import { logger } from "../../../js/log";
import lottie from "lottie-web-limi";
import VoiceEvalResults from "./voiceEvalResults";
if (LIMI_ENV === "electron") {
  var ipc = window.require("electron").ipcRenderer;
}
export default {
  name: "videopage",
  mixins: [telephoneBase,pkJs,answerJs],
  data() {
    return {
      showExeriseList: 1, //展开练习列表
      rateIndex: 3,
      rateArr: ["2.0", "1.5", "1.25", "1.0", "0.8"],
      badgeRank: "",
      rankingData: "",
      danmuShow: true, //弹幕显示隐藏
      addcoin_list: [], //金币添加数组
      addcoin_num: false, //加金币数字
      danmuList: [], //弹幕数据集合
      showExpressionFlag: false, //显示隐藏话术表情,
      bandedType: "", //1解除禁言，2禁言提示,
      lastSendTime: 0, //最后发送弹幕的时间
      questionRight: -1, //题目答对答错
      badgeData: "", //发送的徽章id
      showAnimate: false, //禁言动画
      countNumber: 0, //课前测显示时间
      countDownVal: 15, //倒计时时间
      time_on_off: false, //倒计时是否显示
      openEye: false, //护眼模式默认开启
      progressBar: false, //是否显示进度条
      answerResults: "", //答题对错
      answerAdd: {}, // 答题给的金币能量
      continuousData: {}, //连对动画
      loadingShow: true, //loading组件显示隐藏的标记
      value: undefined, //键盘未填空题时中间区域价盘输入内容和填空题中间区域的绑定
      playerEnterShow: false, //首次进入视频自动播放失败
      showComments: false,
      commentsData:{},//评价消息数据；
      showToast: false,
      showText: "此次课程评价已结束，我们会做的更好的",
      loadingErrShow: false, //视频加载失败
      switchBtnState: 1, //0禁用，1正常，2高亮
      switchToastShow: false, //视频流切换toast是否显示
      switchToastShowInterval: null,
      switchToastText: "", //切换视频流文案
      switchVideoUrlSuccess: true, //是否成功切换清晰度用来控制toast文案
      loadErrText: "加载失败，请点击按钮重新加载~", //视频加载失败显示文案
      toastTime: 3000, //toast显示时间
      videoWH:utils.setVideoWH(100),
      alertText: "",
      LIMI_ENV: LIMI_ENV,
      networkTestDescribeIsShow: false, //网络说明弹窗
      videoSpeedArr: [], //视频当前下载速率数组
      networkStatus: 0, //当前网络状态
      voiceIsStop: false, //语音题是否录音结束
      isAutoSwitch: false, //是否自动切换过
      aiSwitchVideoUrl: false, //是否自动切换
      danmuHeight: 50, //弹幕偏移高度，剪去头部默认为50
      danmuHeightYpercent: 0, //老师头像占高度比例
      issafariBrowser: utils.issafariBrowser(),
      logTimer: null, //埋点计时器
      checkDevicesInterval:null,//检测权限计时器
      exitalert:0,//连麦时退出直播页提示 //0默认 1 展示弹框  2 确认退出
      morebtnShow:false,//更多功能按钮展示
      praiseOrEncourageShow: 0,//表扬鼓励展示 1表扬 2鼓励 3连麦举手
      imageResources:'',
      voiceEvalData:null,// 语音评测结果
      streamList: [],
      classOverImgShow:false,//下课啦图片展示
      classOverAudio:null,
      classBeginAudio:null,
      conAnimShow:true,//是否展示连对效果
      speedShow: false,//是否显示倍速
      giftData:{},
      KBSdefautData: {
        od: {
          good: 110,
          poor: 70
        },
        lc: {
          good: 90,
          poor: 50
        },
        ld: {
          good: 70,
          poor: 30
        }
      }
    };
  },
  components: {
    VoiceEvalResults,
    Answer,
    DanmuList,
    flvplayer,
    kejian,
    Keyboard,
    wordsAndExpression, //话术表情框
    sendGift,
    praise,
    bandedAlert, //系统禁言时的提示
    bandedAnimate, //老师禁言时候的提示
    motivate, //
    continuous,
    loading,
    badge,
    countDown,
    ranking,
    playerEnter,
    Evaluation,
    loaderr,
    Toast,
    Vlcplayer,
    videoplayer,
    videoplayerforai,
    BadgeRank,
    networkTestDescribe,
    pk,
    alert,
    coinex,
    "telephone-panel": telephonePanel
  },
  computed: {
    ...mapState([
      "realname",
      "course_id",
      "lesson_id",
      "lessonCoin",
      "coinAllnum",
      "class_id",
      "teacher_id",
      "grade",
      "teacher_avatar_url",
      "user_photo",
      "userID",
      "imgBaseUrl",
      "continuousRightBaseUrl",
      "banned_speak",
      "text_banned_speak",
      "bzr_text_banned",
      "videoBg",
      "smallClassId",
      "liveVideoUrlData",
      "lesson_type",
      "apiLessonInState",
      "is_typewriting",
      "is_voice_question",
      "connect_wheat",
      "count_online_time_interval",
      "subject",
      "govideo",
      "continuousRightConfig",
      "danmuStyleList",
      "myDanmuStyleId",
      "continuousLevel",
      "lessonState",
      "giftSwitchUniqueId",
      "isSlave",
      "rankRandTimeForClient",
      "userHeadwear",
      "isContinuousRightSetting",
      "barragePosition",
      "smallClassType",
      "class_type",
      "oldUser",
      "playBar",
      "playPoint"
    ]),
    ...mapGetters(["isExperientialCourse"]),
    telephoneClass(){
      if(this.videoWH.w>1740){
        return 'tel-answer_panel-level1'
      }else if(this.videoWH.w>1280){
        return 'tel-answer_panel-level2'
      }
    },
    shortName(){
      const obj = this.liveVideoUrlData.live_video_url_list;
      const stream = this.liveVideoUrlData.live_video_url_stream;
      const type = this.liveVideoUrlData.live_video_url_type;
      return obj && obj[stream] && obj[stream].list && obj[stream].list[type]?obj[stream].list[type].shortName: "标清";
    },
    barragePositionNum(){
      if(this.barragePosition==1){
        const w = document.body.clientWidth;
        const winWidth = w < 1258 ? 1258 : w;
        const r = (winWidth-this.videoWH.w)/2-11;
        return r<0?0:r;
      }else{
        return 0;
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    if(this.currentStatus==="linking" || this.currentStatus==="talking"){
      if(this.exitalert===0){
        this.exitalert = 1;
        return
      }
    }
    if (!to.query.from && this.lesson_id) {
      to.query.from = "video";
      next(to);
      return;
    }
    // console.log("退出video页面");
    this.$root.eventHub.$emit("close_ws");
    this.saveGiftSwitchUniqueId('');
    this.$root.eventHub.$emit("createLog", {
      id: "LMTrackEventLivingOut"
    });
    this.durationRport({
      "time":common.getTemServerTime(),
      "event":2006,
      "data":{
        "class_id":this.class_id,
        "lesson_id":this.lesson_id,
        "student_id":this.userID
      }
    });
    logger.sendByManual();
    this.saveDanmuConfig({});
    next();
  },
  created() {
    if (!this.lesson_id) {
      this.$router.go(-1);
      return;
    }
    this.getVideoPageResources();
    this.durationRport({
      "time":common.getTemServerTime(),
      "event":2005,
      "data":{
        "class_id":this.class_id,
        "lesson_id":this.lesson_id,
        "student_id":this.userID
      }
    })
    //有语音题检测麦克风
    if (this.is_voice_question == 1 || this.connect_wheat == 1) {
      this.$root.eventHub.$emit("checkMicrophonePermission");
    }
    if(this.connect_wheat == 1) {
      this.checkDevicesInterval = setTimeout(()=>{
        this.checkDevicesInterval = null;
        this.$root.eventHub.$emit("open_ws",'0');
      },3000)
      this.checkDevices().then((s) => {
        if(!this.checkDevicesInterval)return;
        this.$root.eventHub.$emit("open_ws",s);
        clearTimeout(this.checkDevicesInterval);
      });

    }else{
      this.$root.eventHub.$emit("open_ws",'0');
    }
    this.danmuShow = !this.govideo;
    this.eventHub();
    this.uploadOnlineTime();
  },
  beforeMount() {
    this.$root.eventHub.$emit("clearTestData");
  },
  mounted() {
    this.resetStreamList()
    this.openEye = LIMI_ENV === "electron" ? utils.getNodeStorge("eyeMode") : common.get("eyeMode");
    this.progressBar = LIMI_ENV === "electron" ? utils.getNodeStorge("progressBar") : common.get("progressBar");
    const conAnimShow = LIMI_ENV === "electron" ? utils.getNodeStorge("conAnimShow") : common.get("conAnimShow");
    this.conAnimShow = conAnimShow!==false?true:conAnimShow;
    this.handleSpeedShow();
    this.openEye && this.initToggoleProtect(false);
    this.progressBar && this.initToggoleProgress();
    window.onresize = this.refreshScreen;
  },
  methods: {
    ...mapMutations([
      "updateLessonCoin",
      "updateAllCoin",
      "updataVideoUrlState",
      "saveDanmuConfig",
      "upDateContinuousLevel",
      "saveGiftSwitchUniqueId"
    ]),
    ...mapActions([
      "getPullUrl",
      "getImageResources",
      "durationRport",
      "getFalseBarrage"
    ]),
    handleSpeedShow() {
      const speedShow = LIMI_ENV === "electron" ? utils.getNodeStorge("speedShow") : common.get("speedShow");
      this.speedShow = speedShow == undefined ? false : speedShow;
    },
    changeRateIndex(index) {
      this.rateIndex = index;
    },
    //显示隐藏题目列表
    clickTagSwitch(type) {
      this.showExeriseList = type;
    },
    //播放器类型
    playerType(){
      if(LIMI_ENV==="electron"){
        return utils.getNodeStorge("playerType") || "vlc";
      }else{
        return "flv"
      }
    },
    resetStreamList () {
      this.streamList = Object.keys(this.liveVideoUrlData.live_video_url_list).filter(v => {
        return this.liveVideoUrlData.live_video_url_list[v].status == 1
            && this.liveVideoUrlData.live_video_url_list[v].type != this.liveVideoUrlData.live_video_url_stream
        })
    },
    //下载送礼物图片资源
    getVideoPageResources(){
      this.imageResources = this.getCatchVideoResources();
      const sendData = {
        subject: this.subject,
        classId: this.class_id,
        teacherId: this.teacher_id,
        isExperience:this.isExperientialCourse?1:0,
        smallClassType:this.smallClassType
      };
      const cUpdateTime =  this.imageResources.continuousRightConfig?this.imageResources.continuousRightConfig.updateTime : 0;
      this.getImageResources(sendData).then(({ res, ok }) => {
        if (!ok) return;
        this.setCatchVideoResources(res);
        utils.loadImage(res.qrCode).then((img)=>{
          this.commentsData.img = img;
        })
        this.imageResources = res;
        if (LIMI_ENV === "electron") {
          let cIsForce = cUpdateTime != res.continuousRightConfig.updateTime;
          res.continuousRightConfig.baseUrl && ipc.send("loadKeJian", {
            url:res.continuousRightConfig.baseUrl + res.continuousRightConfig.pcZipUrl,
            isHoisted:false,
            isForce:cIsForce
          });
           res.gift && res.gift.list.forEach((v)=>{
            ipc.send("loadKeJian", {
              isForce:true,
              url:res.gift.baseUrl+v.imageUrl,
            });
          })
        }else{
          res.continuousRightConfig.list && res.continuousRightConfig.list.forEach(item => {
            const baseUrl = res.continuousRightConfig.baseUrl;
            const directory = item.directory;
            const level = item.level;
            const jsonPath =`${baseUrl}${directory}${level}/${level}.json`;
            this.animInit(jsonPath)
          });
        }
      });
    },
    setCatchVideoResources(res){
      let catchData = (LIMI_ENV === "electron"?utils.getNodeStorge("videoResources"):common.get("videoResources"))||{};
      for(const key in res){
        if(key==='barrage' || key === 'textList'){
          catchData[`${key}_${this.subject}`] = res[key]
        }else{
          catchData[key] = res[key]
        }
      }
      if(LIMI_ENV === "electron") {
         utils.setNodeStorge("videoResources",catchData);
      }else{
         common.set("videoResources",catchData);
      }
    },
    getCatchVideoResources(){
      let catchData = LIMI_ENV === "electron"?utils.getNodeStorge("videoResources"):common.get("videoResources");
      if(!catchData)return {};
      let res = {}
      for(const key in catchData){
        if(!key.includes('barrage_') && !key.includes('textList_')){
          res[key] = catchData[key]
        }
      }
      res.barrage = catchData[`barrage_${this.subject}`] || {};
      res.textList = catchData[`textList_${this.subject}`] || {};
      return res;
    },
    animInit(url){
      let anim = lottie.loadAnimation({
        container: document.querySelector(".cache"), // the dom element that will contain the animation
        renderer: "svg", //svg,canvas
        loop: false,
        autoplay: false,
        path:url
      });
      anim.addEventListener("DOMLoaded",()=>{
        anim.removeEventListener("DOMLoaded")
        anim.destroy();
        anim = null;
      });
    },
    async onAnswer() {
      clearTimeout(this.telInterval);
      this.showExpressionFlag = false;
      this.checkDevices('onAnswer').then(()=>{
        if(this.deviceStatus!=="1"){
          this.showTelToast(3);
          return;
        }
        if(!navigator.onLine){
          this.showTelToast(4)
          return;
        }
        this.join(
          "a17dfbc39a7f4610948e5d4116489cb6",
          "face",
          "006a17dfbc39a7f4610948e5d4116489cb6IAAV6b1fA6IRy69/aj6eYH7Gel+eozs8Ht4THXUkiFwcsGd7FAUAAAAAEAB2N7Fh9cftXgEAAQD1x+1e",
          this.telInfo ? this.telInfo.student_id : null
        );
      })
    },
    //大数据埋点上报在直播页时间
    uploadOnlineTime(){
      this.logTimer = setInterval(() => {
        let type = 1;
        let flag = false;
        let currentTime = undefined;
        if(this.lesson_type==1 || this.lesson_type==5){
          type = 1
        }
        if(this.lesson_type==3 || this.lesson_type==6){
          type = 2
        }
        if (this.isExperientialCourse) {
          let dom =  this.$refs.videoplayer;
          flag = !!(dom && !dom.$refs.video.paused);
          type = 4;
          currentTime = (dom && dom.currentTime) || undefined;
        } else {
          flag = !!(!this.loadingErrShow && this.apiLessonInState === 1);
        }
         if(flag){
            const  sendData = {
            "time":common.getTemServerTime(),
            "event":2001,
            "data":{
              "class_id":this.class_id,
              "lesson_id":this.lesson_id,
              "student_id":this.userID,
              "type":type,
              "length":currentTime
            }
          }
          document.visibilityState==='visible' && this.durationRport(sendData)
          this.$root.eventHub.$emit("createLog", {
            id: "LMTrackEventViewingTime",
            data: {
              lesson_type: this.lesson_type,
              unit: this.count_online_time_interval
            }
          });
        }
      }, 1000 * this.count_online_time_interval);
    },
    //截图
    screenshots() {
      if (LIMI_ENV === "electron") {
        this.showText = "";
        this.showToast = false;
        if(this.isExperientialCourse || this.playerType()==='flv' || this.class_type == 10 || this.class_type == 9){
          utils.screenshotsPc((res)=>{
            if(res==="success"){
              this.showText = "截图已保存到桌面";
              this.showToast = 1;
              this.$root.eventHub.$emit("createLog", {
                id: "LMTrackEventScreeCapture",
                data: {
                  pageType: this.isExperientialCourse?3:1
                },
              });
            }
          })
        }else{
          const url = utils.mkScreenshotsDir() + Date.now() + '.jpeg';
          const player = this.$refs.vlcPlayer.player;
          const ret = player && player.takSnapshot(url);
          if(ret==0){
            this.showText = "截图已保存到桌面";
            this.showToast = 1;
            this.$root.eventHub.$emit("createLog", {
              id: "LMTrackEventScreeCapture",
              data: {
                pageType: this.isExperientialCourse?3:1
              },
            });
          }
        }
      } else {
        utils.downloadScreenshotsWeb();
        this.$root.eventHub.$emit("createLog", {
          id: "LMTrackEventScreeCapture",
          data: {
            pageType: this.isExperientialCourse?3:1
          },
        });
      }
    },
    voiceStop(flag) {
      this.voiceIsStop = flag;
    },
    //检查时间有无超过一天
    checkTime() {
      let nowTime = common.getTemServerTime();
      let oldTime = common.get("currentDayTime1") || 0;
      let nowTimeFormat = utils.dateFormat(
        "YYYY-mm-dd",
        new Date(nowTime * 1000)
      );
      let oldTimeFormat = utils.dateFormat(
        "YYYY-mm-dd",
        new Date(oldTime * 1000)
      );
      if (nowTimeFormat != oldTimeFormat) {
        common.set("currentDayTime1", nowTime);
        return true;
      } else {
        return false;
      }
    },
    //语音题toast提示
    showKejianToast(type) {
      switch (type) {
        case 1:
          this.showText = "麦克风还不能用，快去调试吧~";
          break;
        case 2:
          this.showText = "听不到宝贝的声音，再来一遍说出你的答案吧~";
          break;
        case 3:
          this.showText = "录音时间太短，重新试试~";
          break;
        case 4:
          this.showText = "当前答题的人太多啦，请稍后再试~";
          break;
      }
      this.showToast = 1;
      this.toastTime = 3000;
    },
    //视频流下载kbs
    videoSpeed(speed) {
      this.videoSpeedArr.unshift(speed);
      if (this.videoSpeedArr.length >= 5) {
        this.videoSpeedArr.length = 5;
      }
      let totalSpeed = this.videoSpeedArr.reduce((total, num) => {
          return total + num;
      });
      let average = Math.ceil(totalSpeed / this.videoSpeedArr.length);
      this.setNetworkStatus(average);
      // console.log(average,'-',speed,this.videoSpeedArr);
    },
    //设置网络状态
    setNetworkStatus(average) {
      let data = this.KBSdefautData[
        this.liveVideoUrlData.live_video_url_sub_type
      ];
      if (average >= data.good) {
        this.networkStatus = 2;
      } else if (average < data.good && average >= data.poor) {
        this.networkStatus = 1;
      } else {
        this.networkStatus = 0;
      }
      // console.log(average)
    },
    //去问题反馈页面
    goAdvico(){
      this.$root.eventHub.$emit("createLog", {
        id: "LMTrackEventFeedBack",
        data: {
          page: 1
        }
      });
      this.$router.push({
        path: "/advice"
      });
    },
    //开启连对效果
    setConAnimShow(){
      LIMI_ENV === "electron" ? utils.setNodeStorge("conAnimShow", this.conAnimShow) : common.set("conAnimShow", this.conAnimShow);
      this.$root.eventHub.$emit("createLog", {
        id: "LMTrackEventSwitchLiandui",
        data: {
          class_id: this.class_id,
          action:this.conAnimShow?1:0
        }
      });
    },
    setSpeedShow() {
      LIMI_ENV === "electron" ? utils.setNodeStorge("speedShow", this.speedShow) : common.set("speedShow", this.speedShow);
    },
    //打开关闭护眼模式
    toggoleProtect(needToast) {
      // this.openEye = !this.openEye;
      this.$root.eventHub.$emit("toggoleProtect", {
        openEye: this.openEye,
        needToast
      });
    },
    toggoleProgressBar() {
      this.$root.eventHub.$emit("toggoleProgress", {
        progressBar: this.progressBar,
      });
    },
    initToggoleProtect(needToast) {
      this.$root.eventHub.$emit("toggoleProtect", {
        openEye: this.openEye,
        needToast
      });
    },
    initToggoleProgress() {
      this.$root.eventHub.$emit("toggoleProgress", {
        progressBar: this.progressBar
      });
    },
    exitEnsure(){
      this.exitalert = 2;
      this.goCourse();
    },
    goCourse() {
      this.$router.push({
        path: "/course"
      });
    },
    //计算弹幕高度
    setDanmuH() {
      let winWidth = utils.getClientWidth() < 1258 ? 1258 : utils.getClientWidth();
      let w = (winWidth - this.videoWH.w) / 2;
      let offsetTop = document.getElementById("play_video_sub").offsetTop; //视频局域距离顶部距离-头部高度
      let t =  Math.ceil(this.videoWH.h * this.danmuHeightYpercent) + 12 + offsetTop
      if(this.barragePosition==1 && this.danmuHeightYpercent != 0){
        this.danmuHeight = t
      }else{
        this.danmuHeight = w < 105 && this.danmuHeightYpercent != 0 ? t : 50;
      }
    },
    //全屏点击
    videoClick() {
      this.morebtnShow = false;
      if (this.switchBtnState === 0) return;
      this.switchBtnState = 1;
    },
    showMoreBtn(){
      this.switchBtnState = 1;
      this.morebtnShow = !this.morebtnShow;
    },
    //点击切换流地址按钮
    switchVideoUrl() {
      this.morebtnShow = false;
      if (this.switchBtnState === 0) return;
      //隐藏
      if (this.switchBtnState === 2) {
        this.switchBtnState = 1;
      } else {
        //显示
        this.switchBtnState = 2;
      }
    },
    //获取流列表
    getVideoUrl(unique_id) {
      this.switchBtnState = 0;
      this.getPullUrl({
        lessonId: this.lesson_id,
        version: common.version
      }).then(
        ({ res, ok }) => {
          this.switchBtnState = 1;
          if (!ok) return;
          if (!res || res.length === 0) {
            this.switchBtnState = 0;
          }
          this.checkVideoUrl(unique_id);
        },
        () => {
          this.switchBtnState = 1;
        }
      );
    },
    autoSwitchVideoUrl() {
      let live_video_url_list = this.liveVideoUrlData.live_video_url_list; //所有地址列表
      let live_video_url_sub_type = this.liveVideoUrlData
        .live_video_url_sub_type; //清晰度标识
      let live_video_url_stream = this.liveVideoUrlData.live_video_url_stream; //流类型
      let live_video_type = this.liveVideoUrlData.live_video_type;
      let arr = Object.keys(live_video_url_list[live_video_url_stream].list);
      this.isAutoSwitch = true;
      let index = arr.findIndex(v => {
        return v === live_video_url_sub_type;
      });
      if (!arr[index + 1] || arr[index + 1] === "ai") {
        // console.log('关闭自动切换');
        this.aiSwitchVideoUrl = false;
        return;
      }
      live_video_url_sub_type = arr[index + 1];
      let url = live_video_url_list[live_video_url_stream].list[live_video_url_sub_type][live_video_type];
      this.updataVideoUrlState({
        live_video_url_stream: live_video_url_stream,
        live_video_url_type: this.liveVideoUrlData.live_video_url_type,
        live_video_url_sub_type: live_video_url_sub_type,
        live_video_url: url,
        live_video_type: live_video_type
      });
      this.setVideo();
      this.$root.eventHub.$emit("createLog", {
        id: "LMTrackEventAISwitchStream",
        data: {
          name:
            live_video_url_list[live_video_url_stream].list[
              live_video_url_sub_type
            ].name,
          url: url
        }
      });
    },
    checkVideoUrl(unique_id) {
      let live_video_url_list = this.liveVideoUrlData.live_video_url_list; //所有地址列表
      if (JSON.stringify(live_video_url_list) === "{}") return;
      let live_video_url_type = this.liveVideoUrlData.live_video_url_type; //清晰度模式 高清，标清，智能
      let live_video_url_sub_type = this.liveVideoUrlData
        .live_video_url_sub_type; //清晰度标识
      let live_video_url_stream = this.liveVideoUrlData.live_video_url_stream; //流类型
      let video_type = this.playerType()==='vlc' ? "rtmp" : "flv";
      video_type = this.isExperientialCourse || this.class_type === 10 || this.class_type === 9 ? "mp4" : video_type;
      let live_video_type = this.liveVideoUrlData.live_video_type || video_type; //视频格式
      //缓存为空 默认取第一个可用的
      if (!live_video_url_stream && !live_video_url_type) {
        // console.log("缓存为空");
        let objArr = Object.keys(live_video_url_list);
        let firstData = live_video_url_list[objArr[0]];
        let objArrSub = Object.keys(firstData.list);
        let url_type = objArrSub.includes("ai") ? "ai" : objArrSub[0];
        this.updataVideoUrlState({
          live_video_url_stream: objArr[0],
          live_video_url_type: url_type,
          live_video_url_sub_type: objArrSub[0],
          live_video_url: firstData.list[objArrSub[0]][live_video_type],
          live_video_type: live_video_type
        });
      } else {
        // console.log("缓存不为空");
        let stream = live_video_url_list[live_video_url_stream] || {};
        let arr = Object.keys(stream.list||{});
        if (stream.list && stream.list[live_video_url_sub_type] && arr.includes(live_video_url_type)) {
          if (live_video_url_type === "ai" && !this.isAutoSwitch) {
            live_video_url_sub_type = arr[0];
          }
          this.updataVideoUrlState({
            live_video_url_stream: live_video_url_stream,
            live_video_url_type: live_video_url_type,
            live_video_url_sub_type: live_video_url_sub_type,
            live_video_url:stream.list[live_video_url_sub_type ][live_video_type],
            live_video_type: live_video_type
          });
        } else {
          // console.log("缓存不可用");
          if (stream.list) {
            let url_type = arr.includes("ai") ? "ai" : arr[0];
            let url_sub_type = stream.list[live_video_url_sub_type] ? live_video_url_sub_type : arr[0];
            this.updataVideoUrlState({
              live_video_url_stream: live_video_url_stream,
              live_video_url_type: url_type,
              live_video_url_sub_type: url_sub_type,
              live_video_url:stream.list[url_sub_type][live_video_type],
              live_video_type: live_video_type
            });
          } else {
            this.updataVideoUrlState({
              live_video_url_stream: "",
              live_video_url_type: "",
              live_video_url_sub_type: "",
              live_video_url: "",
              live_video_type: live_video_type
            });
            console.log("当前流下无可用缓存");
            this.checkVideoUrl(unique_id);
          }
        }
      }
      // console.log(`当前流:${this.liveVideoUrlData.live_video_url_stream},当前清晰度:${this.liveVideoUrlData.live_video_url_type},当前流地址:`,this.liveVideoUrlData.live_video_url);
      if (this.liveVideoUrlData.live_video_url_type === "ai") {
        // console.log("开启自动切换逻辑");
        this.aiSwitchVideoUrl = true;
      } else {
        // console.log("关闭自动切换");
        this.aiSwitchVideoUrl = false;
      }
      // this.setVideo();
      if (unique_id) {
        this.$root.eventHub.$emit("createLog", {
          id: "LMTrackEventStreamChange",
          data: {
            unique_id: unique_id,
            name: common.get("liveVideoUrlData").live_video_url_stream,
            url: common.get("liveVideoUrlData").live_video_url,
            reffer: ""
          }
        });
      }
    },
    //根据线路清晰度流地址验证
    verifyVideoUrl(switch_type, type, flag = false) {
      // switch_type 1:切换线路,2:切换清晰度,3:切换视频格式
      let video_type = this.playerType()==='vlc' ? "rtmp" : "flv";
      video_type = this.isExperientialCourse ? "mp4" : video_type;
      let live_video_type = this.liveVideoUrlData.live_video_type || video_type; //视频格式
      let live_video_url_stream = this.liveVideoUrlData.live_video_url_stream;
      let live_video_url_type = this.liveVideoUrlData.live_video_url_type;
      let live_video_url = this.liveVideoUrlData.live_video_url;
      let live_video_url_sub_type = this.liveVideoUrlData
        .live_video_url_sub_type;
      let str = "";
      if (this.apiLessonInState === 2) {
        // this.$root.eventHub.$emit("lessonIn");
        this.$root.eventHub.$emit("restartVideo");
      }
      if (flag) {
        this.streamList.splice(0,this.streamList.length)
      }
      if (switch_type === 1) {
        str = "live_video_url_stream";
        live_video_url_stream = type;
      } else if (switch_type === 2) {
        str = "live_video_url_type";
        live_video_url_type = type;
        //智能模式默认播放第一个
        if (type === "ai") {
          live_video_url_sub_type = Object.keys(
            this.liveVideoUrlData.live_video_url_list[live_video_url_stream]
              .list
          )[0];
          this.aiSwitchVideoUrl = true;
          // console.log("开启自动切换逻辑");
        } else {
          this.aiSwitchVideoUrl = false;
          // console.log("关闭自动切换");
          live_video_url_sub_type = live_video_url_type;
        }
      } else {
        str = "live_video_type";
        live_video_type = this.isExperientialCourse ? "mp4" : type;
      }
      if (this.liveVideoUrlData[str] === type) {
        this.switchBtnState = 1;
        return;
      }
      this.isAutoSwitch = switch_type === 2 ? false : this.isAutoSwitch;
      let listData = this.liveVideoUrlData.live_video_url_list[
        live_video_url_stream
      ].list[live_video_url_sub_type];
      if (!listData) {
        let arr = Object.keys(
          this.liveVideoUrlData.live_video_url_list[live_video_url_stream].list
        );
        live_video_url_sub_type = arr[0];
        live_video_url_type = arr.includes(live_video_url_type)
          ? live_video_url_type
          : live_video_url_sub_type;
        listData = this.liveVideoUrlData.live_video_url_list[
          live_video_url_stream
        ].list[live_video_url_sub_type];
      }
      let url = listData[live_video_type];
      // console.log(live_video_url_stream, live_video_url_type, live_video_type, url);
      this.updataVideoUrlState({
        live_video_url_stream: live_video_url_stream,
        live_video_url_type: live_video_url_type,
        live_video_url: url,
        live_video_url_sub_type: live_video_url_sub_type,
        live_video_type: live_video_type
      });
      // console.log(`手动切换流地址-${live_video_url_stream}-${live_video_url_type}-${url}`);
      this.setVideo();
      this.switchBtnState =(url !== live_video_url && this.apiLessonInState !== 2) ? 0 : 1;
      this.switchToastShow = (url !== live_video_url && this.apiLessonInState !== 2);
      this.switchVideoUrlSuccess = true;
      this.switchToastText = "正在切换";
      clearTimeout(this.switchToastShowInterval);
      this.$root.eventHub.$emit("createLog", {
        id: "LMTrackEventStreamChange",
        data: {
          unique_id: "",
          name: live_video_url_stream,
          url: url,
          reffer: ""
        }
      });
    },
    //点击重试加载视频
    loadvideo() {
      this.getVideoUrl();
      this.loadingErrShow = false;
      this.$root.eventHub.$emit("restartVideo");
      if (this.apiLessonInState === 2) {
        // this.$root.eventHub.$emit("lessonIn");
      }
      //console.log(`点击重试-${this.liveVideoUrlData.live_video_url_stream}-${this.liveVideoUrlData.live_video_url_type}-`,this.liveVideoUrlData.live_video_url);
    },
    changeStream() {
      this.getVideoUrl();
      let type = this.streamList.pop();
      this.verifyVideoUrl(1, this.liveVideoUrlData.live_video_url_list[type].type)
      if (this.streamList.length == 0){
        this.resetStreamList()
      }
    },
    //视频加载失败
    videoLoadErr() {
      console.log('apiLessonInState', this.apiLessonInState)
      if(this.apiLessonInState!=0){
        this.loadingErrShow = true;
      }
      if (this.switchToastShow) {
        this.switchBtnState = 1;
        this.loadErrText = "切换失败，请稍后重试";
        this.switchToastShow = false;
        //console.log(`清晰度切换失败-${this.liveVideoUrlData.live_video_url_stream}-${this.liveVideoUrlData.live_video_url_type}-`,this.liveVideoUrlData.live_video_url);
      } else if (this.streamList.length > 0){
        this.loadErrText = "加载失败，请切换线路重试~";
      }else{
        this.loadErrText = "加载失败，请稍后重试~";
      }
    },
    //toast关闭回调
    toastCallBack() {
      this.toastTime = 3000;
      this.showToast = false;
      if (this.showComments) {
        this.toggleComment(false);
      }
    },
    //徽章关闭回调
    badgeCallback() {
      this.badgeData = "";
    },
    //屏幕尺寸变化时的回调函数
    refreshScreen() {
      this.videoWH=utils.setVideoWH(100);
      this.danmuHeightYpercent = 0;
    },
    canNotPlay(des) {
      this.alertText = des;
    },
    //是否显示loading
    videoTipEvent(flag) {
      if (this.switchToastShow && !flag) {
        this.switchBtnState =
          this.switchBtnState === 0 ? 1 : this.switchBtnState;
        this.switchToastText = "成功切换";
        this.switchVideoUrlSuccess = false;
        clearTimeout(this.switchToastShowInterval);
        this.switchToastShowInterval = setTimeout(() => {
          this.switchToastShow = false;
          //console.log(`成功切换清晰度-${this.liveVideoUrlData.live_video_url_stream}-${this.liveVideoUrlData.live_video_url_type}-`,this.liveVideoUrlData.live_video_url);
        }, 3000);
      }
      if (!flag) {
        this.resetStreamList()
      }
      this.loadingErrShow = flag ? this.loadingErrShow : flag;
      this.loadingShow = flag;
    },
    //自动播放失败点击播放
    firstPlayVideo() {
      this.playerEnterShow = false;
      this.$root.eventHub.$emit("firstPlayVideo");
    },
    //键盘输入内容时更新正在输入的内容
    changeinput(data) {
      this.value = data;
    },
    //控制右侧弹幕区域显示关闭的方法
    changeDanmu() {
      this.danmuShow = !this.danmuShow;
      if (this.danmuShow) {
        this.$root.eventHub.$emit("createLog", {
          id: "LMTrackEventLivingShowDanmu",
          data: {}
        });
      } else {
        this.$root.eventHub.$emit("createLog", {
          id: "LMTrackEventLivingHideDanmu",
          data: {}
        });
      }
    },
    //填空题中间区域点击
    dati_tk(k_on_off) {
      this.k_on_off = k_on_off;
    },
    //选择题按键点击
    dati_xz(data) {
      if (!this.a_on_off) return;
      setTimeout(() => {
        this.closeQuestion();
      }, 600);
      this.$root.eventHub.$emit("answerQuestion", data);
    },
    closeQuestion(origin) {
      //课前测主动关闭类型
      if (
        (origin == "countDown" || origin == "closequestion") &&
        this.quickData[this.iframeQuickId] &&
        this.quickData[this.iframeQuickId].type == 5
      ) {
        this.timeOver = true;
        return;
      }
      if (this.voiceIsStop) {
        this.time_on_off = false; //倒计时
        this.voiceIsStop = false;
        return;
      }
      if((origin == "countDown" || origin == "closequestion") && this.$refs.kejian.closeTimeout>0){
        this.time_on_off = false; //倒计时
        this.$refs.kejian.closeTimeout = 0;
        return;
      }
      // if (origin == "countDown") {
      //   this.answerResults = 'notJoin'
      // }
      this.a_on_off = false; //普通题
      this.time_on_off = false; //倒计时
      this.iframeQuickId = ""; //课件题
      this.gameName = ""; //小游戏
      this.loadGameSuccess = false; //小游戏加载成功标记
      this.questionids = "";
      this.k_on_off = false; //键盘
      this.timeOver = false; //课前测倒计时结束开关
      this.showComments = false; //评价
      if(this.$refs.sendGift){
        this.$refs.sendGift.giftStatus = "close"
        this.$refs.sendGift.alertData = {}
      };
      //console.log("倒计时关闭");
    },
    closeOtherAlert(){
      this.badgeRank = false; //徽章榜
      this.rankingData = ""; //答题榜
      this.badgeData = ""; //徽章
      if(this.pkData.sub_type!=='scoring_result'){
        this.pkData = "";
        this.$refs.pk.close();
      }
      if(this.$refs.sendGift){
        this.$refs.sendGift.giftStatus = "close"
        this.$refs.sendGift.alertData = {}
      };
    },
    showClock(time = 0) {
      if (time === 0 || time === "0") return;
      this.time_on_off = true;
      this.countDownVal = time * 1;
    },
    //填空题确认按钮
    sure(data) {
      this.closeQuestion();
      if (data.answer.replace(/[#|@|\*|\/]/gi, "") == "") return;
      this.$root.eventHub.$emit("answerQuestion", data);
    },
    txt_sure(data) {
      this.closeQuestion();
      if (data.answer.trim() == "") return;
      this.$root.eventHub.$emit("answerQuestion", data);
    },
    //点击发送自定义的表情和话术
    sendWordsOrExpression(opt) {
      this.$root.eventHub.$emit("createLog", {
        id: "LMTrackEventDanmu",
        data: {
          id: opt.id,
          tag: opt.tag,
          text: opt.text || "",
          status: this.banned_speak == 1 || this.banned_speak == 2 ? 0 : 1
        }
      });
      this.showExpressionFlag = false;
      if (this.banned_speak == "1") {
        this.bandedFn("3");
        return;
      }
      if (this.text_banned_speak == "1" && opt.type == 4) {
        this.bandedFn("4");
        return;
      }
      if (this.bzr_text_banned == "1" && opt.type == 4) {
        this.bandedFn("5");
        return;
      }
      this.lastSendTime = Date.now();
      let danmuStyleData = this.danmuStyleList[this.myDanmuStyleId] || {};
      if (opt.type == 4) {
        let answer_level = this.continuousRightConfig[this.continuousLevel] || {};
        const directory = answer_level.directory;
        const level = answer_level.level;
        const cUpdateTime =  this.imageResources.continuousRightConfig?this.imageResources.continuousRightConfig.updateTime : 0;
        const levelUrl = `${
          this.continuousRightBaseUrl
        }${directory}${level}/${level}.png?v=${cUpdateTime}`;
        this.danmuList.push({
          type: 7,
          isOwn: true,
          name: this.realname,
          unique_id: opt.unique_id,
          isRight: true,
          isstandard: true,
          isQuestion: false,
          value: [opt.text],
          txtColor: danmuStyleData.color,
          bgColor: answer_level.barrageColor,
          levelUrl: answer_level.level && this.conAnimShow ? levelUrl : "",
          continuousNum: 0,
          gradient: danmuStyleData.colorList&&danmuStyleData.colorList.length > 1 ? `linear-gradient(180deg,${danmuStyleData.colorList.join(',')})` : null
          // gradient: `linear-gradient(180deg, red, blue)`
        });
        if (this.govideo) {
          top.postMessage({ type: "danmu", data: this.danmuList }, "*");
        }
      }else {
        let barrageObj = {
          answer_continuous: 0,
          answer_level: 0,
          avatar_url: this.user_photo,
          class_id: this.class_id,
          from_nickname: this.realname,
          from_uid: this.userID,
          lesson_id: this.lesson_id,
          msg_body: opt,
          msg_type: 1,
          srv_time: common.getTemServerTime(),
          srv_utime: "",
          stu_cli_time: common.getTemServerTime(),
          student_id: this.userID,
          teacher_id: this.teacher_id,
          text_effect: 0,
          txtColor: danmuStyleData.color,
          gradient: danmuStyleData.colorList&&danmuStyleData.colorList.length > 1 ? `linear-gradient(180deg,${danmuStyleData.colorList.join(',')})` : null
        }
        this.sendPreClassTestBarrage(barrageObj)
      }
      // this.$root.eventHub.$emit("danmuSend", opt);
    },
    bandedFn(type) {
      this.bandedType = type;
      setTimeout(() => {
        this.bandedType = "";
      }, 1200);
    },
    //视频直播页底部弹幕发送区显示隐藏切换
    switchExpressionBox(flag) {
      if (this.iframeQuickId || this.a_on_off || this.showComments) return;
      if (flag) {
        if (this.banned_speak == "1") {
          this.bandedFn("3");
          return;
        }
        let now = Date.now();
        if (now - this.lastSendTime < 3000) {
          this.bandedFn("2");
          return;
        }
        if(!this.imageResources.barrage && !this.imageResources.textList){
          this.getVideoPageResources()
          this.bandedFn("6");
          return;
        }
        if(this.currentStatus==='talking'){
          this.bandedFn("7");
          return;
        }
      }
      this.showExpressionFlag = !this.showExpressionFlag;
    },
    //增加金币时触发
    addCoin(cnum, unique_id, type) {
      if(!cnum || cnum<=0) return;
      let len = this.addcoin_list.length;
      if (len !== 0) {
        setTimeout(() => {
          this.addCoin(cnum, unique_id, type);
        }, 2000);
        return;
      }
      let coin = cnum * 1;
      this.addcoin_list = new Array(coin);
      this.addcoin_num = true;
      let total_coin = this.lessonCoin * 1 + coin;
      let allcoin = this.coinAllnum * 1 + coin;
      this.updateAllCoin(allcoin);
      let logData = {
        danmu_coin: "LMTrackEventAnswerRightCoin",
        normal_listen_lesson: "LMTrackEventGlobalCoin",
        answer_question_excellent: "LMTrackEventAnswerExcelentCoin",
        student_question_excellent: "LMTrackEventStudentExcelentCoin"
      };
      //加金币动画执行
      logData[type] &&
        this.$root.eventHub.$emit("createLog", {
          id: logData[type],
          data: {
            change_count: coin,
            total_count: total_coin
          }
        });
      let timeout = coin>10?11:coin;
      timeout = 1000 + coin * 100
      setTimeout(() => {
        this.updateLessonCoin(total_coin);
        this.addcoin_num = false;
        this.addcoin_list = [];
        let anim = lottie.loadAnimation({
          container: document.querySelector(".goldlottie"), // the dom element that will contain the animation
          renderer: "svg", //svg,canvas
          loop: false,
          autoplay: true,
          path: "/static/lottie/coin.json"
        });
        // anim.play();
        // anim.goToAndStop(610)
        anim.addEventListener("complete", () => {
          anim.destroy();
        });
        //完成加金币
        // this.$root.eventHub.$emit("createLog", {
        //   id: "LMTrackEventAddCoinComplete",
        //   data: {
        //     total_count: total_coin
        //   }
        // });
      }, timeout);
    },
    //控制评价页面显示关闭
    toggleComment(status, unique_id) {
      if(status){
        if(this.commentsData.img || !this.imageResources.qrCode){
          this.showComments = status;
          this.commentsData.unique_id = unique_id
        }else{
          utils.loadImage(this.imageResources.qrCode).then((res)=>{
            this.showComments = status;
            this.commentsData = {
              unique_id:unique_id,
              img:res
            }
          });
        }
      }else{
        this.showComments = status;
        this.commentsData = {};
      }
      if(!status && !this.isExperientialCourse && this.lessonState==3){
        if(this.isSlave==1){
          this.playClassOverAudio();
          return;
        }
        this.goCourse();
      }
    },
    sendPreClassTestBarrage(data) {
      this.formatDamuMessge(data, utils.createUniqueId());
    },
    //弹幕消息格式化方法
    formatDamuMessge(data, unique_id) {
      let questionType = data.question_type;
      let msgType = data.msg_type;
      let uid = data.from_uid;
      let name = data.from_nickname;
      let msgBody = data.msg_body;
      let isRight = data.right;
      let answer = data.answer;
      //type:0 个人文字答案弹幕 1 个人分数弹幕 2 个人根号弹幕  3 个人平方弹幕  4 普通文字弹幕  5 其他人弹幕 6表情弹幕 7文字弹幕
      let isOwn = uid == this.userID;
      let danmuStyleData = this.danmuStyleList[data.text_effect] || {};
      let isstandard =  data.isCorrectAnswer==1? false : (questionType == 1 || questionType == 6);
      let answer_level = this.continuousRightConfig[data.answer_level] || {};
      const directory = answer_level.directory;
      const level = answer_level.level;
      const cUpdateTime =  this.imageResources.continuousRightConfig?this.imageResources.continuousRightConfig.updateTime : 0;
      const levelUrl = `${
        this.continuousRightBaseUrl
      }${directory}${level}/${level}.png?v=${cUpdateTime}`;
      let obj = {
        isOwn,
        name,
        unique_id,
        isstandard,
        isRight: isRight == 1,
        isQuestion: msgType != 1,
        txtColor: danmuStyleData.color || "",
        bgColor: answer_level.barrageColor,
        levelUrl: answer_level.level && this.conAnimShow ? levelUrl : "",
        continuousNum: this.conAnimShow ? (data.answer_continuous || 0):0,
        gradient: danmuStyleData.colorList && danmuStyleData.colorList.length > 1 ? `linear-gradient(180deg,${danmuStyleData.colorList.join(',')})` : null
        // gradient: `linear-gradient(180deg, red, blue)`
      };
      if (msgType == 1) {
        if (msgBody.type==2) {
          obj = Object.assign(obj, {
            type: 6,
            value: this.imgBaseUrl + msgBody.img
          });
        }else{
          if (msgBody.type == 4) {
            obj = Object.assign(obj, {
              type: 7,
              isRight: true,
              isstandard: true,
              value: [msgBody.text]
            });
          } else {
            obj = Object.assign(obj, {
              type: 4,
              isRight: true,
              imgSrc:msgBody.text_img?this.imgBaseUrl + msgBody.text_img:"",
              value: [msgBody.text]
            });
          }
        }
      }else if(msgType == 5){//表扬
        obj = Object.assign(obj, {
          type: 8,
          isRight: true,
          isstandard: true,
          value: [msgBody.pre_text_title,msgBody.text_title,msgBody.text]
        });
      }else if(msgType == 6){//发礼物
        obj = Object.assign(obj, {
          type: 9,
          isRight: true,
          isstandard: true,
          imgurl:msgBody.baseUrl + msgBody.imageUrl,
          value: [msgBody.text]
        });
      } else if (data.sub_type === "G13" || data.sub_type === "G23"){//发礼物
        obj = Object.assign(obj, {
          type: 4,
          isRight: true,
          value: [answer]
        });
      }  else {
        if (isOwn) {
          if (questionType == 6 && data.qtype == 3) {
            obj = Object.assign(obj, {
              type: 7,
              isRight: true,
              isstandard: true,
              value: [answer]
            });
          } else {
            let data = this.Format(answer, true);
            obj = Object.assign(obj, {
              type: data.type,
              value: data.value
            });
          }
        } else if(data.isPublicAnswer==1){
          let data = this.Format(answer, true);
          obj = Object.assign(obj, {
            type: data.type,
            value: data.value
          });
        }else {
          obj = Object.assign(obj, {
            type: 5,
            value: ["***"]
          });
        }
      }
      if (this.danmuList.length >= 30) {
        this.danmuList = [...this.danmuList.slice(-30)];
      }
      this.danmuList.push(obj);
      if (this.govideo) {
        top.postMessage({ type: "danmu", data: this.danmuList }, "*");
      }
    },
    //判断题目答对答错
    questionRightFn(datas) {
      const type = datas.data.question_type,
            right = datas.data.right,
            rightNum = datas.data.answer_continuous,
            coin = datas.data.coin,
            teamScore = datas.data.student_score;
      if(this.conAnimShow){
        for (let v in this.continuousRightConfig) {
          if (this.continuousRightConfig[v].num == rightNum) {
            let data = this.continuousRightConfig[v];
            let continuousLevel = this.continuousLevel || 0;
            data.baseUrl = this.continuousRightBaseUrl;
            this.continuousData = data.level > continuousLevel ? data : "";
            if (this.continuousData) {
              this.continuousData.coin = coin
              this.continuousData.teamScore = teamScore
              this.continuousData.updateTime = this.imageResources.continuousRightConfig.updateTime || 0;
              return;
            }
          }
        }
      }
      //right 0错误  1正确
      let animationType = right == 1 ? "normalRight" : "normalError";
      if (type == 3 || type == 4) {
        const dom = this.$refs.kejian || '';
        this.questionRight = right;
        animationType =  right == 1 ? dom.rightAnimation : dom.wrongAnimation;
      }
      this.answerResults = animationType;
    },
    showPraiseOrEncourage(type){
      if(this.praiseOrEncourageShow){
        this.praiseOrEncourageShow = 0;
        setTimeout(()=>{
          this.praiseOrEncourageShow = type;
        },500)
        return;
      }
      this.praiseOrEncourageShow = type;
    },
    playClassOverAudio(){
      this.classOverImgShow = true;
      this.classOverAudio = new Audio();
      this.classOverAudio.src = this.imageResources.lessonAudioUrl;
      this.classOverAudio.play();
      this.classOverAudio.onerror=(error)=>{
        this.goCourse();
      }
      this.classOverAudio.onended = ()=>{
        this.goCourse();
      }
    },
    playClassBeginAudio() {
      console.log('playClassBeginAudio')
      this.classBeginAudio = new Audio();
      this.classBeginAudio.src = this.imageResources.lessonInMp3 + new Date().getTime();
      this.classBeginAudio.load();
      this.classBeginAudio.play();
      this.classBeginAudio.onerror = (error)=>{
        console.log('audio error');
        this.$root.eventHub.$emit('classVideoPlay');
      }
      this.classBeginAudio.onended = ()=>{
        console.log('audio ended');
        this.$root.eventHub.$emit('classVideoPlay');
      }
    },
    offEventHub() {
      this.$root.eventHub.$off("coin");
      this.$root.eventHub.$off("badge");
      this.$root.eventHub.$off("danmu");
      this.$root.eventHub.$off("obsswitch");
      this.$root.eventHub.$off("teacher_banned");
      this.$root.eventHub.$off("comments");
      this.$root.eventHub.$off("closeQuestion");
      this.$root.eventHub.$off("ranks");
      this.$root.eventHub.$off("badgeRanks");
      this.$root.eventHub.$off("precloseClock");
      this.$root.eventHub.$off("checkMicrophonePermissionError");
      this.$root.eventHub.$off("cameraSize");
      this.$root.eventHub.$off("classOver");
      this.$root.eventHub.$off("giftSwitch");
      this.$root.eventHub.$off("singlePraise");
      this.$root.eventHub.$off("encourage");
      this.$root.eventHub.$off("allPraise");
      this.$root.eventHub.$off("lessonInResult");
      this.$root.eventHub.$off("requestHandup");
      this.$root.eventHub.$off("closeAudio");
      this.$root.eventHub.$off("closeClassBeginAudio");
    },

    //初始化事件传输总线
    eventHub() {
      this.offEventHub();
      this.$root.eventHub.$on('closeClassBeginAudio',()=> {
        console.log('closeClassBeginAudio')
        if(this.classBeginAudio){
          this.classBeginAudio.pause();
          this.classBeginAudio = null;
        }
      }),
      this.$root.eventHub.$on('closeAudio', ()=> {
        if(this.classOverAudio){
          this.classOverAudio.pause();
          this.classOverAudio = null;
          this.classOverImgShow = false
        }
      })
      //单人表扬
      this.$root.eventHub.$on("singlePraise",(datas)=>{
        if(datas.data.msg_body.praise_uid==this.userID){
          this.showPraiseOrEncourage(1);
        }
        this.formatDamuMessge(datas.data, datas.unique_id);
      });
      //全体表扬
      this.$root.eventHub.$on("allPraise",({datas,type})=>{
        let is_self = 0;
        if(datas.data.msg_body && datas.data.msg_body.is_self==1){
          this.showPraiseOrEncourage(1);
          is_self = 1;
        }
        datas.data.msg_body && this.formatDamuMessge(datas.data, datas.unique_id);
        this.$root.eventHub.$emit("createLog", {
          id: "LMTrackEventBatchPraiseData",
          data: {
            source:type,
            unique_id:datas.unique_id,
            is_self
          }
        });
      });
      //鼓励
      this.$root.eventHub.$on("encourage",()=>{
        this.showPraiseOrEncourage(2);
      });
      //连麦举手
      this.$root.eventHub.$on('requestHandup',()=> {
        this.showPraiseOrEncourage(3);
      })
      //麦克风权限失败
      this.$root.eventHub.$on("checkMicrophonePermissionError", code => {
        if (!this.checkTime()) return;
        if (code == 8) {
          this.alertText = "麦克风还不能用,课中无法语音答题,快去调试调试吧~";
        } else {
          if (LIMI_ENV === "electron") {
            this.alertText =
              "当前麦克风为禁止状态，请前往系统设置中开启麦克风权限";
          } else {
            this.alertText =
              "当前麦克风为禁止状态，请前往浏览器或系统设置中开启麦克风权限";
          }
        }
      });
      //送礼物开关
      this.$root.eventHub.$on("giftSwitch", (datas)=>{
        if(datas.data.task_data.state==1){
          this.saveGiftSwitchUniqueId(datas.unique_id);
        }else{
          this.saveGiftSwitchUniqueId('');
        }
      });
      //下课
      this.$root.eventHub.$on("classOver",()=>{
        if(this.showComments || this.isExperientialCourse)return;
        if(this.lesson_type === 1){
          this.playClassOverAudio();
          return;
        }
        this.goCourse();
      });
      //禁言
      this.$root.eventHub.$on("teacher_banned", time => {
        if (time == 0) {
          //解除禁言
          this.bandedFn("1");
        } else {
          //禁言
          this.showAnimate = true;
          setTimeout(() => {
            this.showAnimate = false;
          }, 2000);
        }
      });
      //加金币
      this.$root.eventHub.$on("coin", datas => {
        this.addCoin(datas.data.coin, datas.unique_id, datas.data.type);
        //收到金币消息埋点
        this.$root.eventHub.$emit("createLog", {
          id: "LMTrackEventrReceiveCoin",
          data: {
            unque_id: datas.unique_id,
            coin: Number(datas.data.coin) || ""
          }
        });
      });
      //徽章
      this.$root.eventHub.$on("badge", datas => {
        const time = Math.floor(Math.random()*this.rankRandTimeForClient*1000);;
        setTimeout(()=>{
          this.closeOtherAlert();
          liSrv.getBadgeInVideo({
          batch_id: datas.data.task_data.batch_id, // 星级1-5
          lesson_id: this.lesson_id,
          small_class_id: this.smallClassId || 0
          },(res, ok) => {
            if (ok) {
              if (!res) return;
              //console.log("徽章信息获取成功", res);
              if (this.badgeData) {
                this.badgeData = "";
                //console.log("已经有徽章正在展示先进行关闭操作");
                setTimeout(() => {
                  // console.log("关闭当前徽章界面，准备展示新的徽章");
                  this.badgeData = res;
                }, 1500);
              } else {
                //console.log("开始显示徽章");
                if (res && res.awarded == -1) {
                  this.showText = "很遗憾,未参加活动无法获得徽章";
                  this.showToast = true;
                  this.toastTime = 5000;
                } else {
                  this.badgeData = res;
                }
              }
              this.$root.eventHub.$emit("createLog", {
                id: "LMTrackEventReceiveBadge",
                data: {
                  unique_id: datas.unique_id,
                  id: datas.data.task_data.batch_id,
                  status: res.awarded,
                  refer: "socket"
                }
              });
            }
          },() => {
            this.showText = "徽章信息获取失败";
            this.showToast = true;
            //console.log("徽章信息获取失败");
          });
        },time)
      });
      //课中排榜
      this.$root.eventHub.$on("ranks", datas => {
        this.closeOtherAlert();
        setTimeout(() => {
          datas.data.unique_id = datas.unique_id;
          this.rankingData = datas.data;
        }, 200);
      });
      //徽章排行榜
      this.$root.eventHub.$on("badgeRanks", datas => {
        this.closeOtherAlert();
        setTimeout(() => {
          datas.data.unique_id = datas.unique_id;
          this.badgeRank = datas.data;
        }, 200);
      });
      //课后评价
      this.$root.eventHub.$on("comments", datas => {
        if (datas.data.task_data.show == 1) {
          this.closeQuestion();
          this.value = undefined;
          this.k_on_off = false;
          this.showExpressionFlag = false;
          setTimeout(() => {
            // console.log("显示评价");
            this.toggleComment(true, datas.unique_id);
          }, 1000);

          this.$root.eventHub.$emit("createLog", {
            id: "LMTrackEventReceiveEva",
            data: {
              unique_id: datas.unique_id,
              reffer: datas.resoure
            }
          });
        } else {
          this.$root.eventHub.$emit("createLog", {
            id: "LMTrackEventCancelEva",
            data: {
              unique_id: datas.unique_id,
              reffer: datas.resoure
            }
          });
          //console.log("收到关闭评价的消息客户端主动关闭评价页面");
          if (this.showComments == true) {
            this.showText = "此次课程评价已结束，我们会做的更好的";
            this.showToast = true;
          }
        }
      });
      //弹幕
      this.$root.eventHub.$on("danmu", datas => {
        if (datas.data.from_uid == this.userID) {
          if (datas.data.msg_type == 1 && datas.data.msg_body.type == 4) return;
          //console.log("消息结果",datas)
          if (
            (datas.data.question_type == 2 ||
            (datas.data.isCorrectAnswer == 1 && datas.data.question_type==6) ||
            (datas.data.question_type == 3 || datas.data.question_type == 4)) &&
              datas.data.quick_question_id == this.currentQuestion
          ) {
            this.answerAdd = {
              coin: datas.data.coin,
              teamScore: datas.data.student_score,
              rightAnswer: this.Format(datas.data.right_answer),
              answer: this.Format(datas.data.answer),
              type: datas.data.question_type,
            }
            if(datas.data.voice){
              this.voiceEvalData = datas.data.voice;
              this.voiceEvalData.coin = datas.data.coin;
              this.voiceEvalData.teamScore = datas.data.student_score;
            }else{
              this.questionRightFn(datas);
            }
            this.upDateContinuousLevel({
              continuousNum: datas.data.answer_continuous,
              continuousLevel: datas.data.answer_level
            });
          }
          if (datas.data.coin && datas.data.coin != 0) {
            this.addCoin(datas.data.coin, datas.unique_id, "danmu_coin");
            // console.log("弹幕加金币", datas.data.coin);
            //收到金币消息埋点
            this.$root.eventHub.$emit("createLog", {
              id: "LMTrackEventrReceiveCoin",
              data: {
                unque_id: datas.unique_id,
                coin: Number(datas.data.coin) || ""
              }
            });
          }
          //收到自己弹幕埋点
          this.$root.eventHub.$emit("createLog", {
            id: "LMTrackEventDanmuReceive",
            data: {
              unque_id: datas.unique_id,
              type: datas.data.msg_type,
              answer: datas.data.answer || "",
              coin: Number(datas.data.coin) || ""
            }
          });
        }
        this.formatDamuMessge(datas.data, datas.unique_id);
      });
      // 发伪弹幕
      this.$root.eventHub.$on('sendFalseBarrage',(params,type)=> {
        // 红包雨结束后再出弹幕消息
        let time = [4,5].includes(type * 1) ? params.quickQuestionSubType && params.quickQuestionSubType === 'G23' ? 25000 : 10000 : 2000;
        setTimeout(()=> {
          this.getFalseBarrage(params).then(({ res, ok })=> {
            if(!ok) return;
            if(res && res.length != 0) {
              let k = 0;
              const timeFun = ()=> {
                if(k < res.length) {
                  this.formatDamuMessge(res[k], utils.createUniqueId());
                  k++;
                }
                if(k < res.length) setTimeout(()=> {
                  timeFun()
                },350);
              }
              timeFun();
            }
          })
        }, time)
      })
      //切换流地址
      this.$root.eventHub.$on("obsswitch", datas => {
        // console.log(`收到切流命令`);
        this.getVideoUrl(datas.unique_id);
        //console.log('切换流地址' + data);
      });
      this.$root.eventHub.$on("closeQuestion", datas => {
        if (
          datas.data.task_data.question_id &&
          this.currentQuestion != datas.data.task_data.question_id
        )
          return;
        setTimeout(() => {
          this.closeQuestion("closequestion");
        }, 1100);
      });
      //课前测关闭
      this.$root.eventHub.$on("precloseClock", datas => {
        this.timeOver = true;
        this.time_on_off = false;
      });
      //调整弹幕高度
      this.$root.eventHub.$on("cameraSize", datas => {
        let ypercent = Math.floor(datas.ypercent * 10000) / 10000; //保留四位小数，最后一位不会四舍五入
        // let ypercent = datas.ypercent.toFixed(4) * 1;//保留四位小数，最后一位会四舍五入
        if (this.danmuHeightYpercent === ypercent) return;
        this.danmuHeightYpercent = ypercent;
        this.setDanmuH();
      });
      //进课成功播放视频
      this.$root.eventHub.$on("lessonInResult",this.checkVideoUrl);
    },
    //重置视频播放
    setVideo() {
      //如果当前画面是异常休息或流地址相同不重启播放器
      let live_video_url_now = common.get("live_video_url_now") || "";
      let live_video_url = this.liveVideoUrlData.live_video_url;
      if (live_video_url_now === live_video_url && !this.loadingErrShow)return;
      this.loadingErrShow = false;
      this.playerEnterShow = false;
      this.$root.eventHub.$emit("restartVideo");
    },
    onLottieEnd(){
      this.questionRight = -1;
      this.answerResults = "";
    }
  },
  beforeDestroy() {
    if(this.classOverAudio){
      this.classOverAudio.pause();
      this.classOverAudio = null;
    }
    this.offEventHub();
    clearInterval(this.logTimer);
    window.onresize = null;
  }
};
</script>

<style scoped lang="less" rel="stylesheet/less">
.test_ranking {
  position: fixed;
  top: 60px;
  background: #000;
  padding: 10px 15px;
  left: 30px;
  cursor: pointer;
  color: #fff;
  font-size: 21px;
  text-align: center;
  line-height: 35px;
  border-radius: 8px;
}
.test_ranking1 {
  position: fixed;
  top: 60px;
  background: #000;
  padding: 10px 15px;
  left: 230px;
  cursor: pointer;
  color: #fff;
  font-size: 21px;
  text-align: center;
  line-height: 35px;
  border-radius: 8px;
}
.video {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;
  .top {
    z-index: 998;
    width: 100%;
    height: 50px;
    background: #000;
    position: absolute;
    top: 0;
    .back {
      position: absolute;
      left: 30px;
      top: 7px;
      width: 35px;
    }
    .network_status {
      position: absolute;
      left: 105px;
      top: 7px;
      width: 35px;
      height: 35px;
    }
    .network_good {
      background: url(../../../assets/img/video/network_good.png) no-repeat;
      background-size: 35px 35px;
    }
    .network_general {
      background: url(../../../assets/img/video/network_general.png) no-repeat;
      background-size: 35px 35px;
    }
    .network_poor {
      background: url(../../../assets/img/video/network_poor.png) no-repeat;
      background-size: 35px 35px;
    }
    .goldnum {
      position: absolute;
      font-family: Roboto_Regular;
      right: 30px;
      top: 7px;
      height: 35px;
      line-height: 35px;
      background: url("../.././../assets/img/common/coin.png") no-repeat left
        center;
      background-size: 35px 35px;
      padding-left: 47px;
      padding-right: 16px;
      text-align: left;
      color: #fff;
      background-color: #333333;
      border-radius: 18px;
      font-size: 24px;
      text-align: center;
      z-index: 90;
    }
    .goldlottie {
      position: absolute;
      z-index: 2;
      width: 81px;
      height: 81px;
      left: -23px;
      top: -23px;
    }
    .animation_gold {
      // z-index: 90;
      background-color: rgba(255, 255, 255, 0);
      color: rgba(255, 255, 255, 0);
      transform: translate3d(0, 0, 0);
      animation: animationY linear 1s,
        animationX cubic-bezier(0.645, 0.045, 0.355, 1) 1s;
      z-index: 89;
    }
    .gold_add {
      position: absolute;
      height: 50px;
      color: #ffd300;
      top: 5px;
      width: 60px;
      left: 50%;
      text-align: left;
      transform: translate(50px, 16px);
      animation-fill-mode: both;
      line-height: 43px;
      z-index: 999;
      font-size: 33px;
      font-family: Roboto_Regular;
    }
    .teacher_img {
      background: url("../../../assets/img/video/teacher_bg.png") no-repeat;
      background-size: contain;
      background-position: 2px center;
      position: absolute;
      left: 50%;
      top: 0;
      width: 178px;
      height: 82px;
      margin-left: -89px;
      line-height: 82px;
      text-align: center;
      vertical-align: middle;
      z-index: 90;
      img {
        width: 62px;
        height: 62px;
        border-radius: 31px;
      }
    }
  }
  .play_video {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .play_video_sub {
    display: inline-block;
    position: relative;
  }
  .play_video_mask {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 25;
  }
  .class_over{
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
  .bottom {
    width: 100%;
    height: 50px;
    z-index: 92;
    background: #000;
    position: absolute;
    bottom: 0;
    .whl-student-head-container {
      position: absolute;
      left: 50%;
      bottom: 0;
      width: 178px;
      height: 104px;
      margin-left: -89px;
      line-height: 82px;
      text-align: center;
      vertical-align: middle;
      display: flex;
      justify-content: center;
      &>div:first-child {
        background: url("../../../assets/img/video/student_bg.png") no-repeat;
        background-size: contain;
        background-position: center center;
        width: 178px;
        height: 82px;
        position: absolute;
        bottom: 0;
        left: 0;
      }
      &>div:nth-child(2) {
        width: 104px;
        height: 104px;
        z-index: 2;
        position: absolute;
        //left: 39.5px;
        top: 9px;
        display: flex;
        justify-content: center;
        align-items: center;
        &>img:first-child {
          width: 62px;
          height: 62px;
          border-radius: 50%;
          z-index: 1;
          position: absolute;
        }
        &>img:nth-child(2) {
          width: 104px;
          height: 104px;
          position: absolute;
          top: 0;
          left: 0;
          z-index: 3;
          pointer-events: none;
        }
      }

    }
    .danmu_box {
      position: absolute;
      right: 0;
      top: 7px;
      bottom: 16px;
      height: 35px;
      background: #333333;
      border-radius: 33px 0 0 33px;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0 20px 0 10px;
      .rate {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 27px;
        width: 42px;
        text-align: center;
        padding: 3px 7px;
        border: 2px solid #fff;
        border-radius: 16px;
        font-size: 12px;
        color: #fff;
        box-sizing: border-box;
        margin-right: 10px;
      }
      .switch {
        border-radius: 14px;
        color: #ffffff;
        padding: 3px 7px;
        font-size: 12px;
        border: 2px solid #ffffff;
      }
      .switch--disable {
        color: #8e8e8e;
        border: 2px solid #8e8e8e;
        cursor: default;
        pointer-events: none;
      }
      .switch:hover {
        background: #f57f22;
        border: 2px solid #f57f22;
      }
      .switch--active {
        background: #f57f22;
        border: 2px solid #f57f22;
      }
      .line {
        background: rgba(255, 255, 255, 0.35);
        height: 20px;
        width: 1px;
        margin: 0 10px;
      }
      img {
        width: 28px;
        height: 27px;
        margin-left: 20px;
        &:nth-of-type(1) {
          margin-left: 0;
        }
      }
      img.whl-eye {
        width: 34px;
        height: 33px;
      }
    }
    .switch_hint {
      position: absolute;
      background: rgba(0, 0, 0, 0.7);
      border-radius: 6px;
      padding: 10px 13px;
      color: #ffffff;
      font-size: 14px;
      bottom: 70px;
      left: 20px;
      span {
        color: #f57f22;
      }
    }
    .screenshots--disable{
      pointer-events: none;
      opacity: .7;
    }
    .switch_box {
      position: absolute;
      right: 58px;
      bottom: 60px;
      min-width: 250px;
      max-width: 330px;
      opacity: 0.98;
      background: #f4f4f6;
      box-shadow: -2px 1px 12px 0 rgba(0, 0, 0, 0.08);
      border-radius: 8px;
      text-align: left;
      padding: 30px 0;
      .switch_box_content {
        color: #333333;
        padding-bottom: 40px;
        &:last-child {
          padding-bottom: 0;
        }
        p {
          padding-left: 20px;
          font-size: 20px;
          font-weight: 600;
        }
        button {
          width: 120px;
          height: 50px;
          border: 1px solid #666666;
          font-size: 18px;
          margin: 0 20px;
          border-radius: 6px;
          color: #666666;
          margin-top: 20px;
          position: relative;
          i {
            position: absolute;
            width: 38px;
            height: 24px;
            top: -12px;
            right: -17px;
            line-height: 24px;
            background: #00a5d3;
            color: #fff;
            border-radius: 8px 6px 8px 0px;
            font-size: 14px;
          }
        }
      }
      .switch_box_content--active {
        border-color: #f57f22 !important;
        color: #f57f22 !important;
      }
    }
    .morebtn{
      width: 190px;
      background: rgba(0,0,0,0.7);
      position: absolute;
      right: 14px;
      bottom: 60px;
      border-radius:8px;
      padding-top: 3px;
      text-align: left;
      &::after {
        position: absolute;
        content: " ";
        border-top: 8px solid rgba(0,0,0,0.7);
        border-left: 8px solid transparent;
        transform: rotate(-135deg);
        bottom: -4px;
        border-bottom-right-radius: 2px;
        transform: rotate(135deg);
        right:16px;
      }
      p{
        position: relative;
        color: #FFFFFF;
        font-size: 18px;
        border-top: 1px solid #626262;
        margin: 0 15px;
        padding: 18px 0;
        &:first-child{
          border-top: none;
        }
      }
      label{
        position: absolute;
        width: 55px;
        height: 40px;
        background: red;
        top: 11px;
        right: 6px;
        background: url("../../../assets/img/video/checkbox.png");
        background-size:cover;
      }
      input{
        display: none;
      }
      input:checked + label{
        background: url("../../../assets/img/video/checkbox-checked.png");
        background-size:cover;
      }
      img{
        width: 24px;
        margin-right: 8px;
      }
    }
  }
  .play_control {
    position: absolute;
    top: 0;
    z-index: 80;
    width: 100%;
    height: 100%;
    background: #fdfeff;
    text-align: center;
    color: #003057;
    .play_control_sub {
      position: absolute;
      top: 50%;
      margin-top: -225px;
      width: 100%;
      height: 450px;
    }
    h3 {
      font-size: 28px;
    }
    p {
      padding-top: 16px;
      font-size: 18px;
    }
    img {
      width: 384px;
      height: 384px;
    }
  }
  .control-wordsandexpression-mask {
    height: 100%;
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 90;
    opacity: 0;
  }
  .slideTop-enter-active {
    animation: coinAnimation 0.5s cubic-bezier(0.645, 0.045, 0.355, 1);
  }
  .slideTop-leave-active {
    animation: coinAnimation1 0.5s cubic-bezier(0.645, 0.045, 0.355, 1);
  }
}
.tk-enter-active {
  animation: answer-in .5s cubic-bezier(0.745, 0, 0.31, 0.995);
}
.tk-leave-active {
  animation: answer-out .5s cubic-bezier(0.745, 0, 0.31, 0.995);
}
.xz-enter-active {
  animation: answer-in .5s cubic-bezier(0.745, 0, 0.31, 0.995);
}
.xz-leave-active {
  animation: answer-out 0s .5s cubic-bezier(0.745, 0, 0.31, 0.995);
}
.countDown-enter-active {
  animation: zoomIn 0s 1s;
}
.countDown-leave-active {
  animation: zoomIn 0s 1s;
}
.badge-enter-active {
  animation: badgeBg 0.9s cubic-bezier(0.745, 0, 0.31, 0.995) both;
}
.badge-leave-active {
  animation: badgeBg 0.9s cubic-bezier(0.745, 0, 0.31, 0.995) reverse both;
}
.badge_mask {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 80;
  background: rgba(0, 0, 0, 0.6);
}
@keyframes badgeBg {
  0% {
    opacity: 0;
    transform: scale(0);
  }

  100% {
    opacity: 1;
    transform: scale(1);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bussiness/video/video.vue